import {Component, OnInit} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {WizardEnums} from '../../wizard.namespace';
import {WizardFormService} from '../../services/wizard-form.service';
import {WizardControlService} from '../../services/wizard-control.service';

/* Поля шага визарда 'Руководитель лаборатории' */

@Component({
    providers: [
    ],
    selector: 'laboratory-owner-fields',
    templateUrl: './laboratory-owner.component.html'
})
export class LaboratoryOwnerFieldsComponent extends AbstractFields {
    public slaveTypes = WizardEnums.LaboratorySlaveTypes;

    constructor(
        public wizardForm: WizardFormService,
        private wizardControl: WizardControlService,
    ) {
        super();
    }

    goToFirstStep(event: any) {
        this.wizardControl.activateStep(WizardEnums.Steps.organizationCommon);
    }
}
